export const applySearch = (rows, searchText, columns) => {
  if (!searchText || !searchText.trim()) {
    return rows;
  }

  const search = searchText.trim().toLowerCase();
  return rows.filter((row) => {
    const values = columns
      ? columns.map((column) => {
          const params = { row, field: column.field, value: row[column.field], id: row.id };
          const value = column.valueGetter ? column.valueGetter(params) : params.value;
          return column.valueFormatter ? column.valueFormatter({ ...params, value }) : value;
        })
      : Object.values(row);
    return values.some((value) =>
      String(value ?? '')
        .toLowerCase()
        .includes(search)
    );
  });
};

export const applyColumnSearch = (rows, columnSearch) => {
  const activeFilters = Object.entries(columnSearch)
    .filter(([, value]) => value?.trim())
    .map(([field, value]) => ({
      field,
      value: value.toLowerCase(),
    }));

  if (!activeFilters.length) {
    return rows;
  }

  return rows.filter((row) =>
    activeFilters.every(({ field, value }) =>
      String(row[field] ?? '')
        .toLowerCase()
        .includes(value)
    )
  );
};

export const processClientRows = ({ rows, searchText, columnSearch, columns }) => {
  let result = applySearch(rows, searchText, columns);

  result = applyColumnSearch(result, columnSearch);

  return result;
};
